import { DisplayReward } from "components/DIP/types";
import {
	Box,
	Button,
	ItemImage,
	RewardAmount,
	RewardAmountContainer,
	RewardContainer,
	RewardItem
} from "./styles";

export interface ActionBoxProps {
	rewards?: DisplayReward[];
	onClick: () => void;
	className?: string;
}

export const ActionBox = ({
	rewards,
	onClick,
	className = ""
}: ActionBoxProps) => (
	<Box className={className}>
		<Button
			className={className}
			variant="contained"
			themeColor="primary"
			onClick={onClick}
		>
			ADD
		</Button>
		{rewards?.map((displayReward) => (
			<RewardContainer className={className} key={displayReward.id}>
				<RewardItem>
					<ItemImage
						src={
							displayReward?.imageUrl || displayReward?.overrideImageUrl || ""
						}
						alt=""
					/>
					<RewardAmountContainer>
						<RewardAmount style={{ paintOrder: "stroke fill" }}>
							{displayReward.description}
						</RewardAmount>
					</RewardAmountContainer>
				</RewardItem>
			</RewardContainer>
		))}
	</Box>
);
